import { API, ApiResponseBase, CustomAxiosError } from "../../../../../logics/api-config";
import { useQuery, UseQueryResult } from "react-query";
import { IBillingData } from "../../../../../utils/interfaces/Accounting/Recap/IBillingData";

export interface ApiResponse extends ApiResponseBase {
    data: IBillingData[];
}

async function doGet(): Promise<IBillingData[]> {
    const response = await API.get(`/billing-data`);
    return response?.data;
}

const useApiGetBillingData = (
    options: any = {}
): UseQueryResult<IBillingData[], CustomAxiosError> => {
    return useQuery<IBillingData[], CustomAxiosError>(
        ["getBillingData"],
        () => doGet(),
        { ...options }
    );
};

export default useApiGetBillingData;